import React from 'react'
import { useTranslation } from "react-i18next";

const ROLE_LABEL_MAP = {
  owner: 'staff.role_owner',
  shipping_staff: 'staff.role_shipping',
  customer_support: 'staff.role_support',
};

const Tr = ({ staff, onEdit, onDelete }) => {
    const { t } = useTranslation();

    const roleKey = ROLE_LABEL_MAP[staff.role] || staff.role;

    return (
        <tr>
            <td>{staff.id}</td>
            <td>{staff.name}</td>
            <td>{staff.staff_user_id}</td>
            <td>
                <span className={`staff-role-badge staff-role-badge-${staff.role}`}>
                    {t(roleKey)}
                </span>
            </td>
            <td>
                <button className="staff-list-content-table-button" onClick={() => onEdit(staff)}>{t('staff.edit')}</button>
                <button className="staff-list-content-table-button-delete" onClick={() => onDelete(staff)}>{t('staff.delete')}</button>
            </td>
        </tr>
    )
}

export default Tr
